/*@flow*/
import type { Node } from 'react';
import React, { useReducer, useEffect } from 'react';
import PropertyMap from './PropertyMap';
import SearchAddress from './SearchAddress';
import LocationField from './LocationField';
import Context from './context';
import reducer from './reducer';
import mkState from './mkState';
import commands from './commands';
import type { StateT } from './types';

const Component = (props: $Shape<StateT> = {}): Node => {
  const [state, dispatch] = useReducer(reducer, mkState().mergeDeep(props));
  const ctx = { state, dispatch };

  // When props.fullAddress exists, and state.fullAddress is different,
  // update the value of state.fullAddress.
  useEffect(() => {
    const receivedAddress = props.fullAddress;
    const currentAddress = state.fullAddress;
    if (receivedAddress === currentAddress) return;
    // if (!receivedAddress) return;
    commands(ctx).set('fullAddress', receivedAddress);
  }, [props.fullAddress]);

  // When props.theGeom exists, but state.theGeomOrig does not, set it.
  useEffect(() => {
    if (!props.theGeom) return;
    if (state.theGeomOrig) return;
    commands(ctx).set('theGeomOrig', props.theGeom);
    if (!props.center) return;
    commands(ctx).set('centerOrig', props.center);
  }, [props.theGeom]);

  // When props.theGeom exists, set theGeom in state.
  useEffect(() => {
    if (!props.theGeom) return;
    commands(ctx).set('theGeom', props.theGeom);
  }, [props.theGeom]);

  // When props.center exists, set center in state.
  useEffect(() => {
    if (!props.center) return;
    commands(ctx).set('center', props.center);
  }, [props.center]);

  // When props.onAddressChange exists, set onAddressChange in state.
  useEffect(() => {
    if (!props.onAddressChange) return;
    // Note the use of function. The setter can also take a function
    // and return the current value of the property. In order to set
    // the value of a property to a function, we need to use the function
    // form. Otherwise, the setter will try to use our function to
    // determine its next value.
    commands(ctx).set('onAddressChange', () => props.onAddressChange);
  }, [props.onAddressChange]);

  // When props.onGeomChange exists, set onGeomChange in state.
  useEffect(() => {
    if (!props.onGeomChange) return;
    // Note the use of function. The setter can also take a function
    // and return the current value of the property. In order to set
    // the value of a property to a function, we need to use the function
    // form. Otherwise, the setter will try to use our function to
    // determine its next value.
    commands(ctx).set('onGeomChange', () => props.onGeomChange);
  }, [props.onGeomChange]);

  return (
    <Context.Provider value={ctx}>
      <SearchAddress />
      <PropertyMap />
      <LocationField />
    </Context.Provider>
  );
};

export default Component;
